var helpers = {
  execHooks: function (form, _params) {
    jQuery.each(jQuery(form).find('.js-helper'), function (index, value) {
      _params_local = jQuery(this).attr('data-params')

      _function = jQuery(this).attr('data-function')
      _custom_trigger = jQuery(this).data('trigger')
      _params_local = JSON.parse(_params_local)
      _preHelpers = helpers[_function]
      html = _preHelpers(form, _params_local)
      /********** */
      if (jQuery(this).hasClass('js-remove-active')) {
        html = helpers.jsRemoveActive(html, form, _params_local)
      }
      /** Si setea un active */
      if (jQuery(this).hasClass('js-set-active-ul')) {
        _index = jQuery(this).attr('data-set-active-ul-target')
        html = helpers.jsSetActiveUl(html, _index, form, _params_local)
      }
      /********** */
      //

      if (jQuery(this).hasClass('js-reset-inputs')) {
        html = helpers.jsResetInputs(html, '', form, _params_local)
      }
      if (_custom_trigger) {
        jQuery('body').trigger(_custom_trigger, [html, form, _params])
      }
      /************************* */
      jQuery(this).html(html)
    })
  },
  jsResetInputs: function (html, _index, form, _params) {
    jQuery(html).find('input').val('')
    return jQuery(html)
  },
  jsSetActiveUl: function (html, _index, form, _params) {
    jQuery(html).find(_index).addClass('active')
    return jQuery(html)
  },
  jsRemoveActive: function (html, form, _params) {
    jQuery(html).find('.active').removeClass('active')
    return jQuery(html)
  },
  getDiv: function (form, arr) {
    _div = jQuery(arr[0], form).clone()

    jQuery(_div).attr('style', '').addClass(arr[1])

    return jQuery(_div)
  },
  getRandom: function (min, max) {
    /*
    const min = 3
    const max = 5
    */
    const rand = min + Math.random() * (max - min)
    return Math.round(rand)
  },
  compareArraysUnsort: function (array1, array2) {
    return array1.length === array2.length && array1.sort().every(function (value, index) { return value === array2.sort()[index]})
  },
  compareArrays: function (a, b) {
    if (a === b) return true
    if (a == null || b == null) return false
    if (a.length !== b.length) return false

    // If you don't care about the order of the elements inside
    // the array, you should sort both arrays here.
    // Please note that calling sort on an array will modify that array.
    // you might want to clone your array first.

    for (var i = 0; i < a.length; ++i) {
      if (a[i] !== b[i]) return false
    }
    return true
  },
  getEmptyArray: function (_numInputs) {
    let _initArray = []
    for (let i = 0; i < _numInputs; i++) {
      _initArray[i] = ''
    }
    return _initArray
  },
  init_read: function () {
    jQuery('.readable').each(function (index, value) {
      _button = "<button class='leer btn-lg btn btn-default '><span class='bi bi-volume-up-fill'/></button>"
      jQuery(this).prepend(_button)
    })
  },
  read: function () {
    return "<button class='leer btn  btn-lg btn-default '><span class='bi bi-volume-up-fill'/></button>"
  },
  randomLetter: function (length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },
  requiredAlert: function () {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Olvidaste responder la pregunta.'

    })
  },
  confetti: function (i) {
    _w = window.innerWidth
    _h = window.innerHeight
    _w = _w / 3
    _h = _h / 3
    var t = []
    t[0] = [_w, _h]
    t[1] = [_w, 2 * _h]
    t[2] = [_w, 3 * _h]
    t[3] = [2 * _w, _h]
    t[4] = [2 * _w, 2 * _h]
    t[5] = [2 * _w, 3 * _h]
    t[6] = [3 * _w, _h]
    t[7] = [3 * _w, 2 * _h]
    t[8] = [3 * _w, 3 * _h]

    party.position(t[i][0], t[i][1], {
      count: 40,
      countVariation: 0.5,
      angleSpan: 80,
      yVelocity: -300,
      yVelocityVariation: 1,
      rotationVelocityLimit: 6,
      scaleVariation: 0.8
    })
  },
  playCorrect: function () {
    // soundjs.min.js
    if (jQuery('#play-sounds').is(':checked')) {
      createjs.Sound.play('soundCorrect')
    }
  },
  playError: function () {
    // soundjs.min.js
    if (jQuery('#play-sounds').is(':checked')) {
      createjs.Sound.play('soundError')
    }
  },
  loadSound: function () {
    if (typeof createjs !== 'undefined') {
      createjs.Sound.registerSound(_base_url + 'assets/correcto3.mp3', 'soundCorrect')
      createjs.Sound.registerSound(_base_url + 'assets/aplausos.mp3', 'soundLevelUp')
      createjs.Sound.registerSound(_base_url + 'assets/lose c 03.mp3', 'soundError')
    } else {
      console.log('Not .. createjs ')
    }
  },
  alert: function (message, type) {
    if (type == 0) {
      Swal.fire(
        'Good job!',
        message,
        'success'
      )
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: message

      })
    }
  },
  classFadeIn: 'magictime   puffIn',
  classFadeOut: 'magictime puffOut',
  effectFadeIn: function (obj) {
    jQuery(obj).removeClass(this.classFadeOut).addClass(this.classFadeIn)
  },
  effectFadeOut: function (obj) {
    jQuery(obj).removeClass(this.classFadeIn).addClass(this.classFadeOut)
  },
  _icon: function (tag) {
    icon = ''
    switch (tag) {
      case 'trash':
        icon = '<i class="ti ti-trash"></i>'
        break
      case 'check':
        icon = '<i class="bi bi-check-square"></i>'
        break
      case 'uncheck':
        icon = '<i class="bi bi-square"></i>'
        break

    }
    return icon
  },
  getArrow: function () {
    return '<span class="solution-arrow   blink_me   " style="display:none;"><i class="bi bi-arrow-down-square-fill"></i></span>'
  },
  getRemember: function (title, info) {
    str = '<div class="remember readable alert alert-info d-flex align-items-center">' +
      '<p class="">' +
      '<span class="fs-4  title">' +
      '<i class="bi bi-info-circle"></i>' +
      title +
      '</span>' +
      info +
      '</p>' +
      '</div>'
    return str
  },
  solveEquation: function (equation) {
    parts = equation.split(' ')

    for (i = 0; i < parts.length;i++) {
      console.log(parts[i])
    }
  },
  pluralize: function (number, text) {
    return number === 1 ? text : text + 's'
  },
  plural: function (number, textSingular,textPlural) {
    return number === 1 ? textSingular : textPlural
  },
  mas: function () {
    return '<span class="mas" data-articulate-swap="mas">+</span>'
  }

}

function syntaxHighlight (json) {
  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
    var cls = 'number'
    if (/^"/.test(match)) {
      if (/:$/.test(match)) {
        cls = 'key'
      } else {
        cls = 'string'
      }
    } else if (/true|false/.test(match)) {
      cls = 'boolean'
    } else if (/null/.test(match)) {
      cls = 'null'
    }
    return '<span class="' + cls + '">' + match + '</span>'
  })
}
